import { Edge as RFEdge, Node as RFNode } from "@xyflow/react";
import { z } from "zod";

export const CanvasSchema = z.object({
  account_id: z.number(),
  name: z.string(),
  id: z.string(),
  nodes: z.custom<RFNode[]>(),
  edges: z.custom<RFEdge[]>(),
  node_count: z.number().optional(),
  lastchanged: z.string().nullable(),
  created: z.string().nullable(),
  description: z.string().nullable(),
  customuser_id: z.number().nullable(),
  is_public: z.boolean().optional(),
  access_level: z.enum(["can_edit", "can_view"]),
});

export type Canvas = z.infer<typeof CanvasSchema>;
